export const MARKET_TIMEZONE = 'America/New_York';

export enum Currency {
    UsDollar = 'USD',
    IsraeliNewShekel = 'ILS',
}

export enum AsyncActionStatus {
    Idle = 'idle',
    Pending = 'pending',
    Fulfilled = 'fulfilled',
    Rejected = 'rejected',
}

export enum NewsArticleDataType {
    Stock = 'stock',
    Article = 'article',
}

export enum NewsProvider {
    Passport = 'PASSPORT',
    Benzinga = 'BENZINGA',
}
